var $ = global.jQuery = global.$;
require('../third-party/slick');
var _merge = require('lodash/object/merge');
var _clone = require('lodash/lang/clone');
var utils = require('../lib/utils');
var slickDefaults = require('../config').slick;

var Equalise = require('./Equalise');

/**
 * Slider widget that implements Slick slider with some default options
 * @class
 * @extends Equalise
 */
var _Slider = Equalise.extend(
  /** @lends _Slider.prototype */
  {
  /**
   * Initialisation method
   * @private
   */
   onWidgetsReady: function() {
    var self = this;
    this.$el.data('equaliseTargets', '.equal,[data-slides]');

    //Then call the Equalise widgets own init method
    this._super();

    this.newOpts = this.options;
    this.$slides = this.$el.find('[data-slides]');
    this.$prevArrow = this.$el.find('[data-arrow-prev]');
    this.$nextArrow = this.$el.find('[data-arrow-next]');

    this.options = _merge(_clone(slickDefaults), this.options);

    this.options.appendArrows = this.$el;
    this.options.appendDots = this.$el;
    if (this.$prevArrow.length) this.options.prevArrow = this.$prevArrow;
    if (this.$nextArrow.length) this.options.nextArrow = this.$nextArrow;

    this.$slides.on('init setPosition', function(event, slick) {
      setTimeout(function() {
        self.equalise();
        self.w = utils.getWindow().width;
      }, 600);
    });

    this.$slides.slick(this.options);

  },
  /**
   * Resize handler
   * @private
   */
  _resizeHandler: function() {
    if (utils.getWindow().width !== this.w){
      this.redraw();
    }
  },
  /**
   * Redraws the Slider
   */
  redraw: function() {
    this.$slides.slick('setPosition');
    this.$slides.slick('slickGoTo', 1);
  }
});

module.exports = _Slider;



//////////////////
// WEBPACK FOOTER
// ./source/scripts/widgets/_Slider.js
// module id = 275
// module chunks = 0